import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme';
import { Key } from '../../controls/Key/Key';
import { Mouse } from '../../controls/Mouse/Mouse';

interface IProps {
  className?: string;
}

const CompassHintBase = (props: IProps) => {
  return (
    <div className={props.className}>
      <Key>CTRL</Key> + <Mouse left/>
      Adjust bearing and pitch
    </div>
  );
}

const CompassHint = styled(CompassHintBase)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export { CompassHint }
